import { type FilterConfig, type FilterShape, type FilterQueryInput } from './filterConfig.ts';
import { defaultAuctionStatusFilters } from './filterConfig.ts';

export function urlParamsToFilterState(
    filterConfig: FilterConfig,
    urlParams: URLSearchParams
): FilterShape {
    const filterState: FilterShape = {
        auctionStatus: null,
        marketType: null,
        mediumTypes: null,
        sortBy: null,
    };

    let filterKey: keyof FilterShape;
    for (filterKey in filterState) {
        if (filterState.hasOwnProperty(filterKey)) {
            const config = filterConfig[filterKey];

            if (config) {
                const filterUrlAlias = config.urlAlias;

                if (config.isArray) {
                    const urlParamValues = urlParams.getAll(filterUrlAlias);
                    const allowedValues = urlParamValues
                        .map(valueFromUrl => {
                            const optionByUrlAlias = config.options.find(
                                option => option.urlAlias === valueFromUrl
                            );
                            return optionByUrlAlias?.value;
                        })
                        .filter(Boolean);

                    if (allowedValues.length) {
                        // @ts-ignore
                        filterState[filterKey] = allowedValues;
                    }
                } else {
                    const urlParamValue = urlParams.get(filterUrlAlias);
                    const valueByUrlAlias = config.options.find(
                        option => option.urlAlias === urlParamValue
                    )?.value;

                    if (valueByUrlAlias) {
                        // @ts-ignore
                        filterState[filterKey] = valueByUrlAlias;
                    }
                }
            }
        }
    }

    return filterState;
}

export function filterStateToSearchQueryInput(state: FilterShape): FilterQueryInput {
    return {
        auctionStatuses: state.auctionStatus ? [state.auctionStatus] : defaultAuctionStatusFilters,
        auctionMarketTypes: state.marketType ? [state.marketType] : null,
        mediumTypes: state.mediumTypes?.length ? state.mediumTypes : null,
        sortBy: state.sortBy,
    };
}

export function filterStateToUrl(
    filterConfig: FilterConfig,
    filterState: FilterShape,
    url: URL
): URL {
    for (const filterKey in filterState) {
        if (filterState.hasOwnProperty(filterKey)) {
            const config = filterConfig[filterKey as keyof FilterShape];
            const filterUrlAlias = config.urlAlias;

            url.searchParams.delete(filterUrlAlias);

            const value = filterState[filterKey as keyof FilterShape];
            if (value?.length) {
                const values = Array.isArray(value) ? value : [value];

                // use value aliases instead of actual filter values used in queries
                const valueUrlAliases = values
                    .map(filterValue => {
                        const options = config.options;
                        return options.find(option => option.value === filterValue)?.urlAlias;
                    })
                    .filter((v): v is string => !!v);

                valueUrlAliases.forEach(valueAlias =>
                    url.searchParams.append(filterUrlAlias, valueAlias)
                );
            }
        }
    }

    return url;
}
